// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + "2ba60441" + ".chunk.css");